<template>
  <div>
    <!-- Data Stores Hack, need to be loaded first -->
    
    <!-- Theres something wrong with my api access, so I switched to 
    default instead of tcportalAdmin TODO fix -->
    <TwilioSyncStore service="tcportalAdmin" ref="twilioSyncStore"/>
    <!-- <TwilioSyncStore service="default" ref="twilioSyncStore"/> -->
    <LoggingStore ref="loggingStore"/>
    <!-- ///////////////////////////////////////// -->

    <h1>Function Logging Page</h1>
    
    <FunctionLogging />
    
  </div>
</template>

<script>

import TwilioSyncStore from '../Phone/Stores/TwilioSyncStore.vue'
import LoggingStore from './Stores/LoggingStore.vue'

import FunctionLogging from './Components/FunctionLogging.vue'


export default {
  name:"FunctionLoggingPage",
  components: {FunctionLogging,             TwilioSyncStore, LoggingStore},
  data () { return {
    syncClient: undefined,
  }},
  mounted(){
  },
  provide() {
    console.log(this.$refs);
    return {
      functionLoggingPage: this,
    }
  },
  async mounted(){

  },
  
  
}
</script>

<style scoped>

</style>